import type { i18n } from 'i18next';
import { I18nextProvider } from 'react-i18next';

interface LocalizationProps extends React.PropsWithChildren {
  i18n: i18n;
}

function Localization({ children, i18n }: LocalizationProps) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}

export default Localization;
